import { render, staticRenderFns } from "./DiscussionBoardPosts.vue?vue&type=template&id=29033695&"
import script from "./DiscussionBoardPosts.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports